import Api from "../../../util/Api";

export default function getInitState() {
    return {
        gridIsOpen: true,
        selectedItems: [],
        formIsOpen: false,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            checkbox_rows: true,
            global_search: {
                visibility: false,
            }
        },
        searchFields: [
            {
                name: "patientName",
                label: "Név",
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "treatmentId",
                label: "Kezelés",
                filter: {
                    type: "simple"
                },
                sort: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllTreatmentType,
                    formatText: function (val) {
                        return val.title;
                    },
                    formatOption: function (val) {
                        return val.title;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'title',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                formVisible: true
            },
            {
                name: "doctorId",
                label: "Orvos",
                formSize: 3,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllDoctor,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "companySiteId",
                label: "Ellátóhely",
                formType: "select",
                formSize: 3,
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllCompanySite,
                    formatText: function (val) {
                        return val.siteName;
                    },
                    formatOption: function (val) {
                        return val.siteName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'siteName',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "patientDateOfBirth",
                label: "Páciens születési dátuma",
                formSize: 4,
                formType: "date",
                formVisible: true
            },
            {
                name: "fromDate",
                label: "Dátumtól",
                formSize: 4,
                formType: "date",
                formVisible: true
            },
            {
                name: "toDate",
                label: "Dátumig",
                formSize: 4,
                formType: "date",
                formVisible: true
            },
            {
                name: 'forInsurancePartner',
                label: 'Ellátásszervezőnek',
                formSize: 4,
                formType: 'checkbox',
                formVisible: true
            },
        ],
        headerFields: [
            {
                name: "id",
                label: "Kezelés ID",
                visibility: false
            },
            {
                name: "recordType",
                label: "",
                visibility: true
            },
            {
                name: "treatmentName",
                label: "Kezelések",
                visibility: true
            },
            {
                name: "treatmentPrice",
                label: "Kezelés ára",
                visibility: true,
                slot_name: "currencyFormat3"
            },
            {
                name: "patientName",
                label: "Páciens neve",
                visibility: true
            },
            {
                name: "invoiceNumber",
                label: "Számla sorszáma",
                visibility: true
            },
        ],
        customerHeaderFields: [
            {
                name: "id",
                label: "ID",
                visibility: false,
            },
            {
                name: "customerName",
                label: "Cégnév",
                sort: true,
                visibility: true,
            },
            {
                name: "customerEmail",
                label: "E-mail cím",
                visibility: true,
            },
            {
                name: "taxNumber",
                label: "Adószám",
                visibility: true,
            },
            {
                name: "taxablePersonText",
                label: "Adóalany",
                visibility: true,
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                visibility: true,
            }
        ],
        selectPartnerDataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        selectCustomerDataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        selectPartnerRowActions: [
            {
                btn_text: '<i class="fas fa-arrow-right"></i>',
                title: 'Kiválasztás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'selectPartner'
            }
        ],
        selectCustomerRowActions: [
            {
                btn_text: '<i class="fas fa-arrow-right"></i>',
                title: 'Kiválasztás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'selectCustomer'
            }
        ],
        customerActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
        ],
        customerSearchFields: [
            {
                name: "customerName",
                label: "Cégnév",
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "email",
                label: "E-mail cím",
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "taxNumber",
                label: "Adószám",
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "adoalany",
                label: "Adóalany",
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAdoalanyList,
                        formatText: function (val) {
                            return val.text;
                        },
                        formatOption: function (val) {
                            return val.text;
                        },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'szamlazzId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                formVisible: true
            },
        ],
        selectInsurancePartnerRowActions: [
            {
                btn_text: '<i class="fas fa-arrow-right"></i>',
                title: 'Kiválasztás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'selectInsurancePartner'
            }
        ],
        selectPartnerHeaderFields: [
            {
                name: "name",
                label: "Név",
                filter: {
                    type: "simple",
                }
            },
            {
                name: "addressString",
                label: "Cím",
            },
            {
                name: "taxNumber",
                label: "Adószám"
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        patientCompanyHeaderFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "name",
                label: "Név",
                sort: true,
                formRequired: true,
                formType: "text",
                formSize: 6,
                formVisible: true
            },
            {
                name: "email",
                label: "E-mail",
                formRequired: false,
                formType: "text",
                formSize: 6,
                formVisible: true
            },
            {
                name: "taxNumber",
                label: "Adószám",
                visibility: true,
                formType: "text",
                formSize: 6,
                formVisible: true
            },
            {
                name: "address",
                visibility: false,
                formType: 'address',
                formVisible: true
            },
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary mx-1",
                event_payload: 'resetForm'
            },
            {
                btn_text: 'Hozzáadás',
                event_name: "customClick",
                class: "btn btn-success mx-1",
                event_payload: 'saveNewCompanyForm'
            }
        ],
        searchFormActions: [
            {
                btn_text: '<i class="fas fa-eraser"></i> Szűrők törlése',
                event_name: "customClick",
                class: "btn btn-danger mx-1",
                event_payload: 'resetSearchForm'
            },
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-success mx-1",
                event_payload: 'saveSearchForm'
            }
        ],
        patientFormActions: [
            {
                btn_text: '<i class="far fa-times-circle"></i> Bezár',
                event_name: "customClick",
                class: "btn btn-danger my-custom-class mx-1",
                event_payload: 'closePatientModal'
            },
            {
                btn_text: 'Hozzáadás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class mx-1",
                event_payload: 'saveNewPatient'
            },

        ],
    }
}
